import React, {useEffect} from 'react';

import {Form, Input, Button, Radio, Upload, Checkbox, Row, Col, Typography, Select, DatePicker, Divider, Alert, InputNumber, Card} from 'antd';
import Flex from '../Flex';
const {Text, Title, Paragraph} = Typography;

import {useInput, useNumber} from 'react-hanger';
import {UserCategory, UserGender, UserGrade} from '../../hooks/apis/useUser';

export interface IUserRegisterForm {
  userName: string;
  passwordMd5: string;
  passwordMd5Confirm: string;
}

const UserRegisterForm = (props: {isLoading: boolean; onFinish: (value: IUserRegisterForm) => any}) => {
  const [form] = Form.useForm();
  const userName = useInput('');
  const passwordMd5 = useInput('');
  const passwordMd5Confirm = useInput('');

  const isConfirm = passwordMd5.value === passwordMd5Confirm.value;

  return (
    <React.Fragment>
      <Card title={'注册新账号'}>
        <Form labelCol={{span: 6}} wrapperCol={{span: 14}} layout={'horizontal'} form={form} onFinish={value => props.onFinish(value as IUserRegisterForm)}>
          <Form.Item label={'用户 ID'} name={'userName'} rules={[{required: true}, {pattern: /^[A-Za-z0-9]{0,20}$/, message: '用户 ID 只能由数字和字母组合'}]}>
            <Input size={'large'} placeholder="请输入用户 ID" />
          </Form.Item>
          <Form.Item label={'密码'} name={'passwordMd5'} rules={[{required: true}]}>
            <Input.Password size={'large'} placeholder="请输入密码" />
          </Form.Item>
          <Form.Item
            label={'再次输入密码'}
            name={'passwordMd5Confirm'}
            rules={[
              {required: true},
              ({getFieldValue}) => ({
                validator(rule, value) {
                  if (!value || getFieldValue('passwordMd5') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject('两次输入的密码不一致');
                },
              }),
            ]}>
            <Input.Password size={'large'} placeholder="请再次输入密码" />
          </Form.Item>
          <Row>
            <Col span={6} />
            <Col>
              <Button size={'large'} type="primary" loading={props.isLoading} htmlType="submit">
                立即注册
              </Button>
            </Col>
          </Row>
        </Form>
      </Card>
    </React.Fragment>
  );
};

export default UserRegisterForm;
